export const GET_CHANNEL_IDENTITIES = 'GET_CHANNEL_IDENTITIES';
